app.controller("landingPageController", [
    "$scope",
    "$location",
    "$uibModal",
    "countryConfig",
    "AuthService",
    "UserService",
    "Session",
    "$state",
    "$timeout",
    function ($scope, $location, $uibModal, countryConfig, AuthService, UserService, Session, $state, $timeout) {
        $scope.countryConfig = countryConfig;
        $scope.AS = AuthService;
        $scope.US = UserService;

        $scope.isCheckingSession = true;

        // === Helper Function to Handle Refresh Token Success ===
        function handleSuccessfulMfa(resp) {
            $scope.AS.isProcessing = true;

            // 1. Create Session
            Session.create(
                resp.access_token,
                resp.expires_in,
                resp.headers ? resp.headers("X-USER-ID") : null
            );

            // 2. Check for Password Update (Safe check)
            if ($scope.mfaParameters && $scope.mfaParameters.updatePasswordRequired) {
                $scope.passwordModel = {};
                $scope.userName = $scope.mfaParameters.creds.username;
                $scope.passwordModel.pw_oldpass = $scope.mfaParameters.creds.password;
                $scope.panelTitle = 'Create New Password';
                $scope.loginState = 'passwordUpdate';

                $timeout(() => {
                    const newPasswordField = document.querySelector("#pw1");
                    if (newPasswordField) {
                        newPasswordField.focus();
                    }
                }, 200);

                // Turn off spinners to show the password form
                $scope.isCheckingSession = false;
                $scope.AS.isProcessing = false;

            } else {
                // 3. Normal Success Path: Get User & Redirect
                $scope.US.getUser().then(function (userResp) {
                    Session.setCurrentUser(userResp.data);
                    $state.go("welcome");

                }, function (error) {
                    console.log("Failed to fetch user details", error && error.status);
                    // If getting user fails, reveal login form and stop spinners
                    $scope.isCheckingSession = false;
                    $scope.AS.isProcessing = false;
                });
            }
        }

        function checkSession() {
            // If strictly authenticated already, go now
            if ($scope.AS.isAuthenticated()) {
                $state.go("welcome");
                return;
            }

            // This tab signed out, or chose to sign in as someone else: it waits here for a sign-in of its
            // own rather than continuing whoever is signed in in another tab.
            if (Session.isSignedOutHere()) {
                $scope.isCheckingSession = false;
                return;
            }

            // Attempt Silent Refresh. A tab with a sign-in of its own refreshes that one; a new tab continues
            // the latest sign-in in this browser.
            $scope.AS.refreshAccessToken()
                .then(function (response) {
                    var userId = response.headers && response.headers('x-user-id');

                    if (userId) {
                        // Pass the DATA and the HEADERS function wrapper to our helper
                        // We construct a composite object so handleSuccessfulMfa works as expected
                        var successData = response.data;
                        successData.headers = response.headers;

                        handleSuccessfulMfa(successData);
                    } else {
                        // Success but no user ID? Treat as fail.
                        $scope.isCheckingSession = false;
                    }
                })
                .catch(function () {
                    // Check failed (not logged in), reveal the landing page
                    console.log("Auto-login failed, showing landing page");
                    $scope.isCheckingSession = false;
                });
        }

        // Run immediately
        checkSession();

        $scope.goToFeatures = function (sectionId) {
            $location.path("/features").hash(sectionId);
        };

        $scope.openDemoModal = function (planName) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/src/website/book-demo.modal.html',
                controller: 'bookDemoController',
                backdropClass: 'modern-modal-backdrop',
                windowClass: 'modern-modal-window',
                size: 'md',
                resolve: {
                    selectedPlan: function () {
                        return planName;
                    }
                }
            });

            modalInstance.result.then(function (result) {
                console.log('Modal closed with result:', result);
            }, function (reason) {
                console.log('Modal dismissed:', reason);
            });
        };
    }
]);
